export default __webpack_public_path__ + "static/media/Naplesdick.7e7f6fa3.PNG";